/*
 * Copyright (c) 2021, salesforce.com, inc.
 * All rights reserved.
 * SPDX-License-Identifier: BSD-3-Clause
 * For full license text, see the LICENSE file in the repo root or https://opensource.org/licenses/BSD-3-Clause
 */

import {defineMessages} from 'react-intl'

export const messages = defineMessages({
    profile: {
        defaultMessage: 'Profile',
        id: 'global.account.link.account_details'
    },
    dashboard: {
        defaultMessage: 'Dashboard',
        id: 'global.account.link.dashboard'
    },
    addresses: {
        defaultMessage: 'Addresses',
        id: 'global.account.link.addresses'
    },
    bookings: {
        defaultMessage: 'Bookings',
        id: 'global.account.link.bookings'
    },
    routines: {
        defaultMessage: 'Routines',
        id: 'global.account.link.routines'
    },
    orders: {
        defaultMessage: 'Order History',
        id: 'global.account.link.order_history'
    },
    preferences: {
        defaultMessage: 'Preferences',
        id: 'global.account.link.preferences'
    },
    wishlist: {defaultMessage: 'Wishlist', id: 'global.account.link.wishlist'}
})

export const navLinks = [
    {
        name: 'dashboard',
        path: '/'
    },
    {
        name: 'routines',
        path: '/routines'
    },
    {
        name: 'bookings',
        path: '/bookings'
    },
    {
        name: 'wishlist',
        path: '/wishlist'
    },
    {
        name: 'orders',
        path: '/orders'
    },
    {
        name: 'profile',
        path: '/profile'
    },
    {
        name: 'addresses',
        path: '/addresses'
    },
    {
        name: 'preferences',
        path: '/preferences'
    }
]

export const CONFIRMATION_DIALOG_DEFAULT_CONFIG = defineMessages({
    dialogTitle: {
        defaultMessage: 'Confirm Action',
        id: 'confirmation_modal.default.title.confirm_action'
    },
    confirmationMessage: {
        defaultMessage: 'Are you sure you want to continue?',
        id: 'confirmation_modal.default.message.you_want_to_continue'
    },
    primaryActionLabel: {
        defaultMessage: 'Yes',
        id: 'confirmation_modal.default.action.yes'
    },
    alternateActionLabel: {
        defaultMessage: 'No',
        id: 'confirmation_modal.default.action.no'
    }
})
